import { bus } from '@/validator'

const validatorEmit = {
  validate: ({ namespace, trigger }) => { bus.$emit('validate', namespace, trigger) },
  validated: ({ namespace, result, triggeredBy }) => { bus.$emit('validated', namespace, result, triggeredBy) },
  'partial-validate': ({ namespace, array, trigger }) => { bus.$emit('partial-validate', namespace, array, trigger) },
  'partial-validated': ({ namespace, result, triggeredBy }) => { bus.$emit('partial-validated', namespace, result, triggeredBy) },
  reset: ({ namespace, trigger }) => { bus.$emit('reset', namespace, trigger) },
  reseted: ({ namespace, triggeredBy }) => { bus.$emit('reseted', namespace, null, triggeredBy) }
}

const _validate = (el) => {
  el.validatorWaiting = undefined
  el.validator.response = 'validated'
  el.$validator.validateAll()
  .then((result) => {
    el.validator.result = result
    el.refreshValidationErrors()
    el.validatorWaiting = Array.isArray(el.validator.children)
                         ? el.validator.children.map(namespace => {
                           return {
                             action: 'validate',
                             namespace,
                             trigger: el.validator.namespace
                           }
                         })
                         : []
  })
}

const _reset = (el) => {
  el.validatorWaiting = undefined
  el.validator.response = 'reseted'
  el.$validator.reset()
  .then(() => {
    el.validator.result = undefined
    el.validatorWaiting = Array.isArray(el.validator.children)
                         ? el.validator.children.map(namespace => {
                           return {
                             action: 'reset',
                             namespace,
                             trigger: el.validator.namespace
                           }
                         })
                         : []
  })
}

const _partial = (el, array) => {
  el.validatorWaiting = undefined
  el.validator.response = 'partial-validated'
  let foreign = array.filter(v => v.namespace !== el.validator.namespace)
  Promise.all(
    array.filter(v => v.namespace === el.validator.namespace)
        .reduce((acc, v) => {
          return [ ...acc, ...v.fields.map(f => { return el.$validator.validate(f) }) ]
        }, [ new Promise(resolve => resolve(true)) ]
      ))
  .then((result) => {
    el.validator.result = result.reduce((acc, v) => { return acc && v }, true)
    el.refreshValidationErrors()
    el.validatorWaiting = Array.isArray(foreign)
                           ? foreign.map((x) => {
                             return {
                               action: 'partial-validate',
                               namespace: x.namespace,
                               array: [ x ],
                               trigger: el.validator.namespace
                             }
                           })
                           : []
  })
}

export default {
  data () {
    return {
      validator: {
        children: [],
        namespace: undefined,
        result: undefined,
        triggeredBy: undefined,
        cb: undefined,
        response: undefined
      },
      validatorWaiting: undefined
    }
  },
  watch: {
    validatorWaiting: {
      handler (n, o) {
        if (n === o || !n) return
        if (n.length > 0) {
          n.filter(x => {
            if (!o) return true
            return !o.some(y => x.namespace === y.namespace && x.action === y.action)
          })
          .forEach(w => {
            validatorEmit[w.action](w)
          })
        } else {
          if (this.validator.response) validatorEmit[this.validator.response]({ ...this.validator })
          if (this.validator.result === false) this.$emit('invalid')
          this.validator.triggeredBy = undefined
          this.validator.response = undefined
          this.validatorWaiting = undefined
          if (this.validator.cb) this.validator.cb(this.validator.result)
        }
      },
      deep: true
    }
  },
  methods: {
    refreshValidationErrors () {
      this.veeErrors.items
      .filter(e => !this.$store.state.errors.array.list.some(x => x.id === e.id))
      .forEach(e => {
        if (e.field === 'client-email') {
          if (e.rule === 'email') { this.$store.dispatch('errors/addValidationError', { ...e, namespace: this.validator.namespace, msg: this.$i18n.t('validations.messages.clientEmailInvalid') }) }
          if (e.rule === 'required') { this.$store.dispatch('errors/addValidationError', { ...e, namespace: this.validator.namespace, msg: this.$i18n.t('validations.messages.clientEmailRequired') }) }
        } else { this.$store.dispatch('errors/addValidationError', { ...e, namespace: this.validator.namespace }) }
      })
      this.$store.dispatch('errors/sort')
    },
    onResetValidation (ns, trigger) {
      if (ns !== this.validator.namespace) return
      this.validator.triggeredBy = trigger
      _reset(this)
    },
    onValidate (ns, trigger) {
      if (ns !== this.validator.namespace) return
      this.validator.triggeredBy = trigger
      _validate(this)
    },
    onPartialValidate (ns, array, trigger) {
      if (ns !== this.validator.namespace) return
      this.validator.triggeredBy = trigger
      _partial(this, array)
    },
    onWaitingValidation (ns, res, trigger) {
      if (this.validator.namespace !== trigger) return
      if (!this.validatorWaiting) return
      if (this.validatorWaiting.some(x => x.namespace === ns)) {
        this.validator.result = this.validator.result && res
        this.validatorWaiting = this.validatorWaiting.filter(x => x.namespace !== ns)
      }
    },
    resetValidation (cb = undefined) {
      this.$store.dispatch('errors/empty')
      this.validator.cb = cb
      _reset(this)
    },
    validate (cb = undefined) {
      this.resetValidation(() => {
        this.validator.cb = cb
        _validate(this)
      })
    },
    validatePromise () {
      return new Promise((resolve, reject) => {
        let validatePromiseCallback = (result) => {
          if (result) {
            resolve()
          } else {
            this.scrollToInvalid()
            reject(result)
          }
        }
        this.validate(validatePromiseCallback)
      })
    },
    partialValidate (array, cb = undefined) {
      this.resetValidation(() => {
        this.validator.cb = cb
        _partial(this, array)
      })
    },
    emitValidation (payload, cb = undefined) {
      if (!payload) return
      if (!Array.isArray(payload)) payload = [ payload ]
      this.resetValidation(() => {
        this.validator.cb = cb
        this.validator.result = true
        this.validatorWaiting = payload.map(v => {
          return {
            ...v,
            trigger: this.validator.namespace
          }
        })
      })
    },
    scrollToInvalid () {
      this.$nextTick(() => {
        // let el = this.$root.$el.querySelector('#invalids')
        // if (el) el.scrollIntoView()
      })
    },
    reValidateField (field) {
      return this.$validator.validate(field)
    }
  },
  created () {
    bus.$on('reset', this.onResetValidation)
    bus.$on('reseted', this.onWaitingValidation)
    bus.$on('validate', this.onValidate)
    bus.$on('partial-validate', this.onPartialValidate)
    bus.$on('validated', this.onWaitingValidation)
    bus.$on('partial-validated', this.onWaitingValidation)
  },
  beforeDestroy () {
    bus.$off('reset', this.onResetValidation)
    bus.$off('reseted', this.onWaitingValidation)
    bus.$off('validate', this.onValidate)
    bus.$off('partial-validate', this.onPartialValidate)
    bus.$off('validated', this.onWaitingValidation)
    bus.$off('partial-validated', this.onWaitingValidation)
    this.$store.dispatch('errors/empty')
  }
}
